var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEtc = function SvgEtc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#3AB83A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3325 29.6653C20.3937 31.822 24.6315 34.0796 27.9046 35.8265L39.382 29.6653C35.2262 35.839 31.7636 40.9788 27.9046 46.6671C24.0388 40.9913 19.7695 34.7285 16.3325 29.6653ZM16.7739 27.9623L27.9172 22.0162L38.9154 27.9188L27.9235 33.8715L16.7739 27.9623ZM27.9046 20.1111L16.3325 26.2031L27.8541 9.33374L39.382 26.2408L27.9046 20.1111Z",
    fill: "#3AB83A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9045 35.8265L39.3819 29.6653C35.2261 35.839 27.9045 46.6671 27.9045 46.6671V35.8265ZM27.917 22.0162L38.9152 27.9188L27.9233 33.8715L27.917 22.0162ZM27.9045 20.1116L27.854 9.33374L39.3819 26.2408L27.9045 20.1116Z",
    fill: "#0B8311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7739 27.9625L27.9177 28.877L38.9159 27.9247L27.9234 33.8778L16.7739 27.9625Z",
    fill: "#0B8311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9175 28.877L38.9157 27.9247L27.9238 33.8778L27.9175 28.877Z",
    fill: "#146714"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.4167C12.8582 55.4167 0.583333 43.1418 0.583333 28H-0.583333C-0.583333 43.7861 12.2139 56.5833 28 56.5833V55.4167ZM55.4167 28C55.4167 43.1418 43.1418 55.4167 28 55.4167V56.5833C43.7861 56.5833 56.5833 43.7861 56.5833 28H55.4167ZM28 0.583333C43.1418 0.583333 55.4167 12.8582 55.4167 28H56.5833C56.5833 12.2139 43.7861 -0.583333 28 -0.583333V0.583333ZM28 -0.583333C12.2139 -0.583333 -0.583333 12.2139 -0.583333 28H0.583333C0.583333 12.8582 12.8582 0.583333 28 0.583333V-0.583333Z",
    fill: "#080808",
    fillOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0495,
    height: 37.3333,
    fill: "white",
    transform: "translate(16.3335 9.33337)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEtc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ETC.b8ba08cfd008973507870e22f323a2a2.svg";